
import { defineComponent, ref, Ref, inject, computed, watch, onMounted } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const materials = computed<any>(() =>
      store.getters.materials.sort((a: any, b: any) => {
        if (Number(a.position) > Number(b.position)) {
          return 1;
        } else {
          return -1;
        }
      })
    );

    const currentLabelType = computed<string>(() => store.state.currentLabelType);
    const currentLabelMaterialId = computed<number>(() => store.state.currentLabelMaterialId);

    const currentMaterial = ref({} as any);
    const selectedMaterialId = ref(currentLabelMaterialId.value);
    watch(currentLabelMaterialId, (newId: number) => {
      selectedMaterialId.value = newId;

      const foundMaterial = materials.value.find((material: any) => Number(material.id) === newId);

      if (foundMaterial) {
        currentMaterial.value = foundMaterial;
      } else {
        if (
          currentLabelType.value === "rollprinted" ||
          currentLabelType.value === "custom-rollprinted"
        ) {
          currentMaterial.value.title = "White BOPP Permanent";
        } else {
          currentMaterial.value.title = "Standard White";
        }
      }
    });

    onMounted(() => {
      const foundMaterial = materials.value.find(
        (material: any) => Number(material.id) === currentLabelMaterialId.value
      );

      if (foundMaterial) {
        currentMaterial.value = foundMaterial;
      } else {
        if (
          currentLabelType.value === "rollprinted" ||
          currentLabelType.value === "custom-rollprinted"
        ) {
          currentMaterial.value.title = "White BOPP Permanent";
        } else {
          currentMaterial.value.title = "Standard White";
        }
      }
    });

    onMounted(() => {
      const foundMaterial = materials.value.find(
        (material: any) => Number(material.id) === currentLabelMaterialId.value
      );

      if (foundMaterial && foundMaterial.id) {
        const materialsContainer = document.getElementById(foundMaterial.id.toString());

        if (materialsContainer) {
          materialsContainer.style.background = "#0096ff15";

          const listContainer = document.getElementById("modal-materials-container");

          if (listContainer) {
            const sizeContainerBoundingRect = materialsContainer.getBoundingClientRect();
            const listContainerBoundingRect = listContainer.getBoundingClientRect();

            // prettier-ignore
            listContainer.scroll( 0, sizeContainerBoundingRect.top - listContainerBoundingRect.top - sizeContainerBoundingRect.height / 2 );
          }
        }
      }
    });

    const selectedMaterial = ref({} as any);
    const handleInput = (mat: any): void => {
      const foundMaterial = materials.value.find((material: any) => material.id === mat.id);

      if (foundMaterial) {
        const materialContainer = document.getElementById(foundMaterial.id);
        const prevMaterialContainer = document.getElementById(selectedMaterialId.value.toString());

        if (materialContainer && prevMaterialContainer) {
          prevMaterialContainer.style.background = "";
          materialContainer.style.background = "#0096ff15";
          selectedMaterialId.value = Number(foundMaterial.id);
        }

        selectedMaterial.value = foundMaterial;
      }
    };

    const changeMaterial = async (): Promise<void> => {
      await store.dispatch(ActionTypes.CHANGE_LABEL_MATERIAL, selectedMaterial.value);
      closeModal();
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      materials,
      currentLabelMaterialId,
      currentMaterial,
      handleInput,
      changeMaterial,
    };
  },
});
